import { Intent } from "lib/common/enums";
import useCheckUsername from "lib/hooks/register/useCheckUsername";
import useOnboardReqWithTempToken from "lib/hooks/register/useOnboardReqWithTempToken";
import React, { useEffect, useRef, useState } from "react";
import Button from "../atomic/Button";
import { ButtonSpinner } from "../atomic/Spinner/Spinner";
import TextField from "../atomic/TextField";
import { Form } from "../Form";
import FormControl from "../Form/FormControl";
import Spacer from "../Form/Spacer";
import { IoMail } from "react-icons/io5";
import { FaAddressCard } from "react-icons/fa";
import { EmailIcon, UserDetailIcon, UserIcon } from "../Icon";
import useOnboardReqWithBearerToken from "lib/hooks/register/useOnBoardReqWithBearerToken";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getUser } from "redux/reducers/userSlice";
import router from "next/router";
import { hideAuthDrawer } from "redux/reducers/drawerSlice";
import useSWR from "swr";
import { getIoeColleges } from "lib/common/endpoints/public";
import SelectCollege from "./SelectCollege";
import collegeList from "lib/data/collegeList";

interface userInfoProps {
  nextTab?: () => void;
  prevTab?: () => void;
}

function UserInfo({ nextTab }: userInfoProps) {
  const { reqWithBearerToken, loading, error, success } =
    useOnboardReqWithBearerToken();
  const [filledValue, setFilledValue] = useState(false);
  const [institute, setInstitute] = useState("");
  const User = useAppSelector(getUser);
  const dispatch = useAppDispatch();
  const onInstituteChange = (val: string) => {
    setInstitute(val);
  };

  useEffect(() => {
    if (success && nextTab) {
      // dispatch(hideAuthDrawer());
      nextTab();
      localStorage.removeItem("registerToken");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <div className={"py-13 max-w-screen-sm"}>
      <Form
        onSubmit={(value) => {
          reqWithBearerToken(
            "set_user_profile",
            {
              ...value,
              showProfilePicture: false,
              institution: institute,
            },
            "put"
          );
        }}
      >
        <Spacer id="userInfo" className="flex flex-col  pt-5 sm:pt-10 pb-5">
          <div className="mb-5 sm:mb-0 flex-1">
            <div className="flex ">
              <div className="pr-3">
                <h6 className="text-gray-700">
                  User Details{" "}
                  <span className="text-base font-normal">(optional)</span>
                </h6>

                <p className="text-gray text-sm">
                  Personal details. This information will only be mandatory if
                  you opt to take classes
                </p>
              </div>
            </div>
          </div>

          <Spacer className="flex-1">
            <FormControl
              className="mb-5"
              name="fullName"
              label="Full Name"
              defaultValue={User?.fullName}
            >
              <TextField
                stateChange={(e) => {
                  e.target.value.length > 0 && setFilledValue(true);
                }}
                type="text"
                className="rounded bg-gray-50"
              />
            </FormControl>
            <FormControl
              className="mb-5"
              name="address"
              label="Address"
              defaultValue={User?.address}
            >
              <TextField
                stateChange={(e) => {
                  e.target.value.length > 0 && setFilledValue(true);
                }}
                type="text"
                className="rounded bg-gray-50"
              />
            </FormControl>
            {/* <FormControl
              className="mb-5"
              name="institution"
              label="Institution"
              defaultValue={User?.institution}
            >
              <TextField
                stateChange={(e) => {
                  e.target.value.length > 0 && setFilledValue(true);
                }}
                type="text"
                className="rounded bg-gray-50"
              />
            </FormControl> */}
            <SelectCollege
              value={User?.institution}
              onChange={onInstituteChange}
              colleges={collegeList}
            />
          </Spacer>
        </Spacer>
        <Spacer id="userInfo" className="flex flex-col  pt-5 sm:pt-10 pb-5">
          <div className="mb-5 sm:mb-0 flex-1">
            <div className="flex flex-col">
              <div className="pr-3">
                <h6 className="text-gray-700">
                  Email Backup
                  <span className="text-base font-normal">(optional)</span>
                </h6>

                <p className="text-gray text-sm">
                  Add an extra layer of security to your account with backup for
                  email.
                </p>
              </div>
            </div>
          </div>

          <Spacer className="flex-1">
            <FormControl
              defaultValue={User?.userData?.email}
              className="mb-5"
              name="email"
              label="Email Address"
            >
              <TextField
                type="email"
                stateChange={(e) => {
                  e.target.value.length > 0 && setFilledValue(true);
                }}
                className="rounded bg-gray-50"
              />
            </FormControl>
          </Spacer>
        </Spacer>
        <Spacer>
          <Button
            onClick={() => nextTab && nextTab()}
            className="rounded-lg bg-gray-100 px-5 mr-2 text-gray "
          >
            Skip for now
          </Button>
          <Button className="rounded-lg px-6" type="submit" disabled={loading}>
            {loading ? (
              <div>
                <span className="mr-3">Sending...</span>
                <ButtonSpinner />
              </div>
            ) : (
              <span>Continue</span>
            )}
          </Button>
        </Spacer>
      </Form>
    </div>
  );
}

export default UserInfo;
